import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Tabs from "../components/targetAchivment/Tabs";
import { useGetManageAwardQuery } from "../store/apis/configurationApis";
import usePermission from "../helper/usePermission";
import { acl } from "../helper/userAccessConstant";
import { current } from "@reduxjs/toolkit";

interface TabCategory {
  id: number;
  name: string;
  targetCount: number;
  path: string;
}

const ConfigurationContainer = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [manageAwardData, setManageAwardData] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { permissions } = usePermission();

  // Get configuration permissions
  const configPermissions = permissions[acl.configuration.module];

  // Filter tabs based on permissions
  const availableTabs = [
    configPermissions?.manage_score && {
      id: 0,
      name: "Manage Score",
      targetCount: 400,
      path: "manage-score",
    },
    configPermissions?.manage_award && {
      id: 1,
      name: "Manage Award",
      targetCount: 200,
      path: "manage-award",
    },
    configPermissions?.targets && {
      id: 2,
      name: "Targets",
      targetCount: 100,
      path: "targets",
    },
  ].filter(Boolean) as TabCategory[];

  // const { data: awardData, isLoading, error } = useGetManageAwardQuery({
  //   pageNo: "1",
  //   pageSize: "10",
  // });

  const currentPath = location.pathname.split("/").pop();
  useEffect(() => {
    const matchingTab = availableTabs?.find(
      (tab: any) => tab?.path === currentPath
    );
    if (matchingTab?.id !== 0) {
      setActiveTab(0);
      navigate(`/configuration/${availableTabs[0]?.path}`);
    }
  }, []);
  

  const handleCategoryChange = (id: number | undefined) => {
    const selectedTab: any = availableTabs?.find((tab: any) => tab?.id === id);
    if (selectedTab) {
      setActiveTab(selectedTab.id);
      navigate(`/configuration/${selectedTab?.path}`);
    } else {
      setActiveTab(0);
    }
  };

  return (
    <Stack>
      <Tabs
        tabs={availableTabs}
        handleTabChange={handleCategoryChange}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <Outlet context={{ manageAwardData }} />
    </Stack>
  );
};

export default ConfigurationContainer;
